import React, {Component} from 'react'
import { Switch, Checkbox, Button, Popconfirm, message } from 'antd'
import {removeItemFromBox} from "../../../services/api/apiNextBox"

class TableHeadBoxItems extends Component {
    state = {
        loading: false
    }

    _handleChangeChecked = (e) => {
        const {onCheckAll} = this.props
        const checked = e.target.checked

        if (typeof onCheckAll === 'function') {
            onCheckAll(checked)
        }
    }

    hanldeRemoveListBoxs = async () => {
        this.setState({
            loading: true
        })
        try {
            const {arrSelected, onRefresh, onCheckAll} = this.props
            const data = await Promise.all(arrSelected.map(item => {
                return this.hanldeRemoveBoxItem(item)
            }))

            if(Array.isArray(data) && !!data.length && data.every(i => !!i && i.success)){
                message.success('Xóa item trong thùng thành công!')
                onCheckAll(false)
                onRefresh()
            }else{
                const itemErr = data.filter(i => !!i && !i.success) || []
                const {message : err} = !!itemErr && !!itemErr[0] && itemErr[0]

                message.error(err)
            }
        } catch (error) {
            window.alert(error.message)
        }finally{
            this.setState({
                loading: false
            })
        }
    }

    hanldeRemoveBoxItem = async (item = {}) => {
        const {barcode} = Object.assign({}, item)
        const {_id: boxId} = this.props.box

        try {
            const {success, message} = await removeItemFromBox(boxId, barcode)

            if (!success) return {
                success: false,
                message
            }

            return {
                success: true,
            }

        } catch (err) {
            console.log(err.message)
        }
    }

    render() {
        const { isAdmin, showDelete, handleCheckDelete, selectAll, arrSelected, loading } = this.props
        const messNoti = (!!arrSelected.length && arrSelected.map(i => `#${i.barcode}`).join(', ') || '')
        return (
            <thead className="TableHeadBoxItems">
                <tr>
                    {showDelete && 
                        <td>
                            <Checkbox 
                                checked={selectAll}
                                onChange={this._handleChangeChecked}
                                okButtonProps={{
                                    loading,
                                }}
                            />
                            {!!arrSelected.length && 
                            <Popconfirm
                                title={`Bạn có chắc chắn muốn xóa item ${messNoti} khỏi thùng`}
                                onConfirm={this.hanldeRemoveListBoxs}
                                placement="topRight"
                                okText="Yes"
                                cancelText="No"
                                overlayClassName='confirmRemoveBox'
                            >
                                <Button className='ml-2' type="danger" size='small'>
                                    Xóa {`(${arrSelected.length} ${arrSelected.length > 1 ? 'items' : 'item'})`}
                                </Button>
                            </Popconfirm>
                            }
                        </td>
                    }
                    <th>#</th>
                    <th>ID
                        {isAdmin &&
                            <Switch
                                className='ml-2'
                                value={showDelete}
                                checkedChildren="Xóa"
                                unCheckedChildren="Xóa"
                                title='Tắt/Bật xóa item thùng'
                                onChange={handleCheckDelete}
                            />
                        }
                    </th>
                    <th>Loại sản phẩm</th>
                    <th>Size</th>
                    <th>Location</th>
                    <th>Tracking</th>
                    <th>Thời gian đóng gói</th>
                    <th>Shipment Status</th>
                </tr>
            </thead>
        )
    }
}

export default TableHeadBoxItems
